import { generateId } from './utils';
export const createViewStacks = () => {
    let viewStacks = {};
    const getViewStack = (outletId) => {
        return viewStacks[outletId];
    };
    const registerIonPage = (viewItem, ionPage) => {
        viewItem.ionPageElement = ionPage;
    };
    const findViewItemByRouteInfo = (routeInfo, outletId) => {
        return findViewItemByPath(routeInfo.pathname, outletId);
    };
    const findLeavingViewItemByRouteInfo = (routeInfo, outletId) => {
        return findViewItemByPath(routeInfo.lastPathname, outletId);
    };
    const findViewItemInStack = (path, stack) => {
        return stack.find((viewItem) => {
            if (viewItem.pathname === path) {
                return viewItem;
            }
            return undefined;
        });
    };
    const findViewItemByPath = (path, outletId) => {
        if (outletId) {
            const stack = viewStacks[outletId];
            if (!stack)
                return undefined;
            return findViewItemInStack(path, stack);
        }
        for (let outletId in viewStacks) {
            const stack = viewStacks[outletId];
            const viewItem = findViewItemInStack(path, stack);
            if (viewItem) {
                return viewItem;
            }
        }
        return undefined;
    };
    const createViewItem = (outletId, vueComponent, matchedRoute, routeInfo, ionPage) => {
        return {
            id: generateId('viewItem'),
            pathname: routeInfo.pathname,
            outletId,
            matchedRoute,
            ionPageElement: ionPage,
            vueComponent,
            ionRoute: false,
            mount: false
        };
    };
    const add = (viewItem) => {
        const { outletId } = viewItem;
        if (!viewStacks[outletId]) {
            viewStacks[outletId] = [viewItem];
        }
        else {
            viewStacks[outletId].push(viewItem);
        }
    };
    const remove = (viewItem, outletId) => {
        if (!outletId) {
            throw Error('outletId required');
        }
        const viewStack = viewStacks[outletId];
        if (viewStack) {
            viewStacks[outletId] = viewStack.filter(item => item.id !== viewItem.id);
        }
    };
    const getChildrenToRender = (outletId) => {
        const viewStack = viewStacks[outletId];
        if (viewStack) {
            const components = viewStacks[outletId].filter(v => v.mount);
            return components;
        }
        return [];
    };
    return {
        findViewItemByRouteInfo,
        findLeavingViewItemByRouteInfo,
        createViewItem,
        getChildrenToRender,
        add,
        remove,
        registerIonPage,
        getViewStack
    };
};
//# sourceMappingURL=viewStacks.js.map